import { isJsonSchema } from 'js/lib/SchemaValidationUtils';

/**
 * @param semanticSchema - The semantic schema object from a data set, expected to have
 *                        schema_classification.properties structure
 * @returns The normalized semantic schema properties, or null if the schema is invalid
 */
export function getSemanticSchema(semanticSchema: any): any {
  if (!semanticSchema?.schema_classification?.properties) return null;

  const schemaClassification = semanticSchema.schema_classification.properties;

  if (isJsonSchema(schemaClassification)) return schemaClassification.properties;

  return schemaClassification;
}
